import { render, staticRenderFns } from "./BatchTestResults.vue?vue&type=template&id=6201b9aa&scoped=true&"
import script from "./BatchTestResults.vue?vue&type=script&lang=js&"
export * from "./BatchTestResults.vue?vue&type=script&lang=js&"
import style0 from "./BatchTestResults.vue?vue&type=style&index=0&id=6201b9aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6201b9aa",
  null
  
)

export default component.exports